document.addEventListener("DOMContentLoaded", function () {
    let width = getScreenWidth();
    let screen = width > 630 ? "desktop" : "mobile";
    let sliderBrandsImages = initSlider(screen === "mobile");

    document.querySelectorAll(".eggo-brands__images-inner .swiper-slide").forEach(function (brandImage) {
        brandImage.addEventListener("click", function () {
            if (screen === "mobile") return;
            switchSlide(brandImage.dataset.index);
        })
    })

    window.addEventListener("resize", function () {
        width = getScreenWidth();
        if (width > 630 && screen === 'mobile') {
            sliderBrandsImages.destroy();
            sliderBrandsImages = initSlider(false);
            screen = "desktop";
            return;
        }

        if (width <= 630 && screen === 'desktop') {
            sliderBrandsImages.destroy();
            sliderBrandsImages = initSlider(true);
            screen = "mobile";
            return;
        }
    });
});
const getScreenWidth = () => {
    return (window.innerWidth > 0) ? window.innerWidth : screen.width;
}
const switchSlide = (index) => {
    const brandsTextWrapper = document.querySelector(".eggo-brands__texts-inner");
    document.querySelectorAll(".eggo-brands__text").forEach(function (brandText) {
        brandText.classList.remove("active");
    });
    const textSlide = brandsTextWrapper.querySelector(`.eggo-brands__text[data-index='${index}']`);
    textSlide.classList.add("active");

    const brandsImageWrapper = document.querySelector(".eggo-brands__images-inner");
    document.querySelectorAll(".eggo-brands__images-inner .swiper-slide").forEach(function (brandImage) {
        brandImage.classList.remove("active");
    });
    const imageSlide = brandsImageWrapper.querySelector(`.swiper-slide[data-index='${index}']`);
    imageSlide.classList.add("active");
}


const initSlider = (loop = true) => {
    const slider = new Swiper('.eggo-brands__images', {
        slidesPerView: 1,
        centeredMode: true,
        loop: loop,
        breakpoints: {
            320: {
                slidesPerView: 'auto',
                centeredSlides: true
            },
            630: {
                slidesPerView: 3
            }
        },
        on: {
            init: function (swiper) {
                switchSlide(swiper.realIndex);
            }
        }
    });
    slider.on("slideChangeTransitionEnd", function (swiper) {
        switchSlide(swiper.realIndex);
    });
    return slider;
}